import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, inject } from '@angular/core';
import { AlertController, IonicModule } from '@ionic/angular';
import { CachedProfile } from 'src/app/models/CachedProfile';
import { CachedProfilesService } from 'src/app/services/cached-profiles.service';

export type { CachedProfile } from 'src/app/models/CachedProfile';

@Component({
  selector: 'app-logifit-cached-profiles-list',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './logifit-cached-profiles-list.component.html',
  styleUrls: ['./logifit-cached-profiles-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'logifit-cached-profiles-list' }
})
export class LogifitCachedProfilesListComponent implements OnInit {

  @Input() showSectionHeader = false;
  @Input() sectionTitle = 'Profielen';
  @Input() listId = 'cached-profiles';
  @Output() profileSelect = new EventEmitter<CachedProfile>();
  @Output() profilesChanged = new EventEmitter<CachedProfile[]>();

  cachedProfiles: CachedProfile[] = [];

  private cachedProfilesService = inject(CachedProfilesService);
  private alertController = inject(AlertController);

  ngOnInit() {
    this.refreshProfiles();
  }

  public refreshProfiles(): void {
    this.cachedProfiles = this.cachedProfilesService.getProfiles();
    this.profilesChanged.emit(this.cachedProfiles);
  }

  public menuTriggerId(index: number): string {
    return `${this.listId}-menu-${index}`;
  }

  public selectProfile(profile: CachedProfile, event?: Event): void {
    const target = event?.target as HTMLElement | undefined;
    if (target?.closest('.profile-menu-btn, ion-popover')) {
      return;
    }

    this.profileSelect.emit(profile);
  }

  public onMenuButtonClick(event: Event): void {
    event.stopPropagation();
  }

  public async confirmDelete(profile: CachedProfile): Promise<void> {
    const alert = await this.alertController.create({
      header: `${profile.naam} van dit apparaat verwijderen?`,
      message: 'Dit verwijdert alleen het opgeslagen profiel op dit apparaat. Het LogiFit-account blijft bestaan.',
      buttons: [
        {
          text: 'Annuleren',
          role: 'cancel'
        },
        {
          text: 'Verwijderen',
          role: 'destructive',
          handler: () => {
            this.deleteProfile(profile.username);
          }
        }
      ]
    });

    await alert.present();
  }

  public deleteProfile(username: string): void {
    this.cachedProfilesService.removeProfile(username);
    this.refreshProfiles();
  }

}
